import { cssInterop } from 'nativewind';
import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Circle, Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

function SmartTradeIconRaw({
  style,
  stroke,
}: {
  style?: StyleProp<ViewStyle>;
  stroke?: string;
  className?: string;
}) {
  return (
    <Svg width="46" height="46" viewBox="0 0 46 46" fill="none" style={style}>
      <Circle cx="23" cy="23" r="22.5" stroke={stroke} />
      <Path
        d="M24.4336 22.0435V12.8616C24.4336 12.4777 24.8483 12.237 25.1817 12.4275L30.8773 15.6821C31.0331 15.7711 31.1292 15.9368 31.1292 16.1162V18.6957M31.1292 18.6957L27.7814 20.6087M31.1292 18.6957L33.7224 19.9922C33.8918 20.0769 33.9988 20.2501 33.9988 20.4395V25.5605C33.9988 25.7499 33.8918 25.9231 33.7224 26.0078L31.1292 27.3043V30.3432C31.1292 30.5325 31.0222 30.7057 30.8529 30.7904L25.1572 33.6382C24.8248 33.8044 24.4336 33.5627 24.4336 33.191V25.3913"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <Path
        d="M21.5664 23.9565L21.5664 33.1384C21.5664 33.5223 21.1517 33.763 20.8183 33.5725L15.1227 30.3179C14.9669 30.2289 14.8708 30.0632 14.8708 29.8838L14.8708 27.3043M14.8708 27.3043L18.2186 25.3913M14.8708 27.3043L12.2776 26.0078C12.1082 25.9231 12.0012 25.7499 12.0012 25.5605L12.0012 20.4395C12.0012 20.2501 12.1082 20.0769 12.2776 19.9922L14.8708 18.6957L14.8708 15.6568C14.8708 15.4675 14.9778 15.2943 15.1471 15.2096L20.8428 12.3618C21.1752 12.1956 21.5664 12.4373 21.5664 12.809L21.5664 20.6087"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>
  );
}

export const SmartTradeIcon = nativewindWrapSvg(SmartTradeIconRaw);